// extracted by mini-css-extract-plugin
export default {"wrapper":"style_wrapper__clDcE","textWrapper":"style_textWrapper__Mefjc","img":"style_img__t+jzg","inactiveTab":"style_inactiveTab__UOSZi","activeTab":"style_activeTab__QnYJl"};